"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledErrorText = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
//
// properties
//
const config_1 = require("../../assets/styles/config");
exports.StyledErrorText = styled_components_1.default.div `
  color: ${config_1.colors.redError};
  font: ${config_1.fontSizes.base} ${config_1.fontFamilies.primary};
  margin-top: 30px;
  text-align: center;
`;
